import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { css } from "styled-components";

wishListCardStyles.gridContainer = {
    gap: 5,
    css: css`
        > div[class^="GridOffset"] {
            width: calc(100% + 5px);
        }
    `,
};
